/* eslint-disable react-hooks/exhaustive-deps */
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { updateAuthorizationSummary, getFeeRecordsByFileId } from '../store/actions/authorizations.actions';
import { GET_FEE_RECORDS_FAILURE } from '../store/types/authorizationTypes';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import {
  Box,
  Button,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  ThemeProvider,
  Typography
} from '@mui/material';
import { Link } from 'react-router-dom';
import { currencyFormatter } from 'utilities/currencyFormatter';
import { getClientContractFees, setClientId } from 'modules/clients/clients.actions';
import CrudTableComponent from 'modules/clients/details/crudTable.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { UPDATE_AUTHORIZATIONS_FAILURE } from '../types';
import { POST_FEE_SUCCESS } from 'modules/fees/fees.types';
import { postFee } from 'modules/fees/fees.actions';
import { TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';

const PENDING_GUID = 'd29d41c4-7285-42ae-9262-3e24e61c1af9';

const FinanceAndTaxCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  //const [voucherSummaries] = useState([]);
  const [feeBillModal, setFeeBillModal] = useState(false);

  const { details, clientInfo, enumerations, id, history, isReadOnly = false } = props;

  const reloPolicyInfo =
    clientInfo && clientInfo.clientDetails.clientRelocationPolicies && details
      ? clientInfo.clientDetails.clientRelocationPolicies.find(
        crp => crp.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId
      )
      : null;
  const billingPolicyInfo =
    reloPolicyInfo && clientInfo && clientInfo.clientDetails.clientBillingPolicies
      ? clientInfo.clientDetails.clientBillingPolicies.find(
        cbp => cbp.billingPolicy.billingPolicyId === reloPolicyInfo.policy.clientBillingPolicyId
      )
      : null;

  const payPoliciesOptions =
    clientInfo && clientInfo.clientDetails && clientInfo.clientDetails.payPolicies
      ? clientInfo.clientDetails.payPolicies.map(pp => ({ id: pp.recordID, title: `${pp.policyCode} - ${pp.description}` }))
      : [];

  const feeStatuses =
    enumerations && enumerations.allEnums && enumerations.allEnums.feeStatuses.length > 0
      ? enumerations.allEnums.feeStatuses.filter(s => s.isActive === true)
      : [];

  const feeTypes =
    enumerations && enumerations.allEnums && enumerations.allEnums.feeBatchTypes.length > 0
      ? enumerations.allEnums.feeBatchTypes.filter(s => s.isActive === true)
      : [];

  const maritalStatuses =
    enumerations && enumerations.allEnums && enumerations.allEnums.maritalStatuses.length > 0
      ? enumerations.allEnums.maritalStatuses.filter(ms => ms.isActive === true)
      : [];

  const taxFilingStatuses =
    enumerations && enumerations.allEnums && enumerations.allEnums.taxFilingStatuses.length > 0
      ? enumerations.allEnums.taxFilingStatuses.filter(ms => ms.isActive === true)
      : [];

  const [feeRecords, setFeeRecords] = useState(details.feeRecords ? details.feeRecords : []);
  //let recurringPayments = voucherSummaries.filter(sum => sum.isRecurringPayment === true);
  let feeRules = details.feeRules ? details.feeRules : [];

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  let mappedFeeRecords =
    feeRecords && feeRecords.length > 0
      ? feeRecords.map(fr => {
        return {
          feeRecordId: fr.feeRecordId,
          feeType: fr.feeBatchTypeId ? feeTypes.find(t => t.id === fr.feeBatchTypeId).title : '',
          feeStatus: fr.feeStatusId ? feeStatuses.find(s => s.id === fr.feeStatusId).title : '',
          feeAmount: feeRules && feeRules.length > 0 ? feeRules.find(r => r.feeRule.clientFeeId === fr.feeRuleId).feeRule.feeAmount : 0,
          feeInitiationDate: fr.feeInitiationDate
        };
      })
      : [];

  let mappedFeeRules =
    feeRules && feeRules.length > 0
      ? feeRules.map(f => {
        return {
          id: f.feeRule.clientFeeId,
          title: f.feeRule.feeLineDescription
        };
      })
      : [];

  const adjustedColumns = [
    { accessorKey: 'feeRecordId', header: 'Fee Id', type: 'text', required: true, size: 75, hideInModal: true, hideInTable: true },
    { accessorKey: 'feeType', header: 'Fee Type', type: 'text', required: true, size: 75 },
    { accessorKey: 'feeStatus', header: 'Fee Status', type: 'text', required: true, size: 75 },
    { accessorKey: 'feeAmount', header: 'Amount', type: 'money', required: true, size: 75 },
    {
      header: 'Effective Date',
      accessorKey: 'feeInitiationDate',
      type: 'date',
      required: false,
      tab: 1,
      disabled: true,
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-'),
      size: 65
    }
  ];

  const customAddColumns = [
    {
      header: 'Select Fee',
      accessorKey: 'clientFeeId',
      type: 'dropdown-v2',
      options: mappedFeeRules,
      tab: 1,
      size: 70,
      required: true
    },
    {
      header: 'Fee Type',
      accessorKey: 'feeTypeId',
      type: 'dropdown-v2',
      options: feeTypes,
      tab: 1,
      size: 70,
      required: true
    }
  ];

  const summaryTabs = [{ header: 'Finance and Tax', order: 1, iconPath: ['fa', 'dollar'] }];

  const fields = [
    {
      header: 'Billing Policy',
      accessorKey: 'clientBillingPolicy',
      type: 'text',
      value: billingPolicyInfo ? billingPolicyInfo.billingPolicy.billingPolicyDescription : '',
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Tax Policy',
      accessorKey: 'payPolicyRecordId',
      type: 'dropdown-v2',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.payPolicyRecordId : '',
      tab: 1,
      options: payPoliciesOptions
    },
    {
      header: 'Short Term Assignment',
      accessorKey: 'shortTermAssignment',
      type: 'checkbox',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.isShortTermAssignment : false,
      tab: 1
    },
    {
      header: 'Title',
      accessorKey: 'jobTitle',
      type: 'text',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.jobTitle : '',
      tab: 1
    },
    {
      header: 'Department',
      accessorKey: 'department',
      type: 'text',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.department : '',
      tab: 1
    },
    {
      header: 'Marital Status',
      accessorKey: 'maritalStatusId',
      type: 'dropdown-v2',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.maritalStatusId : '',
      tab: 1,
      options: maritalStatuses
    },
    {
      header: 'Tax Filing Status',
      accessorKey: 'taxFilingStatusId',
      type: 'dropdown-v2',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.taxFilingStatusId : '',
      tab: 1,
      options: taxFilingStatuses
    },
    {
      header: 'Relocation Allowance Amount',
      accessorKey: 'relocationAllowanceAmount',
      type: 'money',
      required: false,
      value: details && details.authorizationDetails ? details.authorizationDetails.relocationAllowanceAmount : '',
      tab: 1
    },
    {
      header: 'Relocation Payment Date',
      accessorKey: 'relocationPaymentDate',
      type: 'date',
      required: false,
      value: details && details.authorizationDetails && details.authorizationDetails.relocationPaymentDate ? new Date(details.authorizationDetails.relocationPaymentDate) : '',
      tab: 1
    },
    {
      header: 'Spousal Assistance Estimated Date',
      accessorKey: 'spousalAssistanceEstimatedDate',
      type: 'date',
      required: false,
      value: details && details.authorizationDetails && details.authorizationDetails.spousalAssistanceEstimatedDate ? new Date(details.authorizationDetails.spousalAssistanceEstimatedDate) : '',
      tab: 1
    }
  ];

  const createFee = async values => {
    const feeInfo = {
      feeRecordId: 0,
      authorizationFileId: id,
      feeRuleId: values.clientFeeId,
      feeInitiationDate: new Date(),
      priorStatusId: PENDING_GUID,
      feeStatusId: PENDING_GUID,
      feeBatchTypeId: values.feeTypeId,
      feeVoucherId: 0,
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date()
    };

    const postFeeResp = await props.postFee(feeInfo);
    if (postFeeResp.type === POST_FEE_SUCCESS) {
      props.showToast('Successfully created new fee!', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      const getFeesResp = await props.getFeeRecordsByFileId(id);
      if (getFeesResp.type === GET_FEE_RECORDS_FAILURE) {
        props.showToast('Failed to retrieve fee records.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
      setFeeRecords(getFeesResp.response);
      setFeeBillModal(false);
    } else {
      props.showToast('Failed to create fee, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  };

  const buttonComponent = () => {
    const processedExpensesTotal =
      details.authExpenses && details.authExpenses.expenseLines
        ? details.authExpenses.expenseLines
          .filter(el => (el.approvalStatus === 'Partial Approved' || el.approvalStatus === 'Approved') && el.apPosted != null)
          .reduce((total, el) => {
            return total + parseFloat(el.amount);
          }, 0)
        : 0.0;
    const unprocessedExpensesTotal = details.authExpenses
      ? details.authExpenses.submittedExpenses
        .filter(se => se.isExpenseApproved !== true)
        .reduce((total, se) => {
          return total + se.total;
        }, 0)
      : 0;
    const unapprovedExpensesTotal =
      details.authExpenses && details.authExpenses.expenseLines
        ? details.authExpenses.expenseLines
          .filter(el => el.approvalStatus === 'Partial Approved' || el.approvalStatus === 'Denied')
          .reduce((total, el) => {
            return total + parseFloat(el.denied);
          }, 0)
        : 0.0;
    const unpaidExpensesTotal =
      details.authExpenses && details.authExpenses.expenseLines
        ? details.authExpenses.expenseLines
          .filter(el => (el.approvalStatus === 'Partial Approved' || el.approvalStatus === 'Approved') && el.apPosted == null)
          .reduce((total, el) => {
            return total + parseFloat(el.amount);
          }, 0)
        : 0.0;

    return (
      <Grid container sx={{ marginTop: '10px' }}>
        <Grid item md={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box>
              <Typography variant="body2">
                <Typography variant="body2">Recurring Payments: {details.recurringPayablesCount.recurringPayableCount}</Typography>
              </Typography>
            </Box>
            <Box sx={{ paddingTop: '10px' }}>
              <Typography variant="body2">
                {isReadOnly ? (
                  `Fees Billed: ${feeRecords.length ?? 0}`
                ) : (
                  <Link onClick={() => setFeeBillModal(true)}>Fees Billed: {feeRecords.length ?? 0}</Link>
                )}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box>
              <Typography variant="body2">
                <Link to={`/authorizations/${props.id}/expenses`}>Expenses</Link>
              </Typography>
            </Box>
            <Box sx={{ paddingTop: '5px', display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ marginRight: '5px' }}>
                <Typography variant="body2">Processed:</Typography>
              </Box>
              <Typography variant="body2" color="secondary">
                {currencyFormatter({ value: processedExpensesTotal })}
              </Typography>
            </Box>
            <Box sx={{ paddingTop: '5px', display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ marginRight: '5px' }}>
                <Typography variant="body2">Unprocessed:</Typography>
              </Box>
              <Typography variant="body2" color="secondary">
                {currencyFormatter({ value: unprocessedExpensesTotal })}
              </Typography>
            </Box>
            <Box sx={{ paddingTop: '5px', display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ marginRight: '5px' }}>
                <Typography variant="body2">Unapproved:</Typography>
              </Box>
              <Typography variant="body2" color="secondary">
                {currencyFormatter({ value: unapprovedExpensesTotal })}
              </Typography>
            </Box>
            <Box sx={{ paddingTop: '5px', display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ marginRight: '5px' }}>
                <Typography variant="body2">Unpaid:</Typography>
              </Box>
              <Typography variant="body2" color="secondary">
                {currencyFormatter({ value: unpaidExpensesTotal })}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  };

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newVals = { ...details.authorizationDetails };
    newVals.isShortTermAssignment = values.shortTermAssignment;
    newVals.jobTitle = values.jobTitle;
    newVals.department = values.department;
    newVals.maritalStatusId = values.maritalStatusId === '' ? null : values.maritalStatusId;
    newVals.taxFilingStatusId = values.taxFilingStatusId === '' ? null : values.taxFilingStatusId;
    newVals.relocationAllowanceAmount = values.relocationAllowanceAmount === '' ? null : values.relocationAllowanceAmount;
    newVals.relocationPaymentDate = values.relocationPaymentDate === '' ? null : values.relocationPaymentDate;
    newVals.spousalAssistanceEstimatedDate = values.spousalAssistanceEstimatedDate === '' ? null : values.spousalAssistanceEstimatedDate;
    newVals.payPolicyRecordId = values.payPolicyRecordId === '' ? null : values.payPolicyRecordId;

    const resp = await props.updateAuthorizationSummary(newVals);
    if (resp.type === UPDATE_AUTHORIZATIONS_FAILURE) {
      props.showToast('Failed to update the auth summary info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <EditableCard
        tabs={summaryTabs}
        summaries={fields}
        numColumns={2}
        updateFields={updateFields}
        isLoading={isLoading}
        ButtonComponent={isReadOnly ? null : buttonComponent}
        hideEdit={isReadOnly}
      />
      <Dialog open={feeBillModal} onClose={() => setFeeBillModal(false)} fullWidth maxWidth="lg">
        <DialogTitle>Fees Billed</DialogTitle>
        <DialogContent>
          <CrudTableComponent
            showBasicTable={true}
            editingMode={'modal'} // Can be changed to 'row' to edit inline
            columns={adjustedColumns}
            createRow={createFee}
            rows={mappedFeeRecords ?? []}
            onRowClick={row => {
              const feeRecordId = row.original.feeRecordId;
              if (feeRecordId) {
                history.push(`/fees/${feeRecordId}`);
              }
            }}
            customCreateColumns={customAddColumns}
            customAddText={'Manually Add Fee'}
            hideEdit={true}
            hideAdd={false}
          />
        </DialogContent>
        <DialogActions sx={{ p: '1.25rem' }}>
          <Button color="primary" onClick={() => setFeeBillModal(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  return {
    fullClientsInfo: state.clients.clientsInfo
  };
};

export default compose(
  connect(mapStateToProps, {
    updateAuthorizationSummary,
    showToast,
    getClientContractFees,
    setClientId,
    postFee,
    getFeeRecordsByFileId
  })
)(FinanceAndTaxCard);
